import React from "react";
import { t } from "i18next";

import { ButtonComp } from "components";

const NormalOptionTile = ({ icon, label, onClick, classes }) => {
  return label === "cancel" ? (
    <>
      <div style={{ borderLeft: "1px solid #999" }} className="hayley-mb-2 hayley-pl-2" />
      <ButtonComp testId={label} className={`${classes}`} rounded={true} label={t(label)} onClick={onClick} icon={icon} />
    </>
  ) : (
    <ButtonComp testId={label} className={`${classes}`} rounded={true} label={t(label)} onClick={onClick} icon={icon} />
  );
};

export default NormalOptionTile;
